import React from 'react';
import './value.css';

function Work(props) {
    console.log(props)
    return(
        <div className="value wrapper">
            <div className="value-text">
                <h2 className="value-title">{props.title}</h2>
                <div class="line"><span></span></div>
                <p className="value-description">{props.description}</p>
            </div>
        </div>
    );
}

export default Work;